import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
/**
 * Formatea una fecha al formato estándar: "05 Oct 2025"
 * @param date - Fecha a formatear (string, Date, null o undefined)
 * @returns Fecha formateada o "—" si no es válida
 */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "—";
  // Formato: 05 Oct 2025
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };
  const formatted = d.toLocaleDateString("es-ES", options);
  // Capitalizar primera letra del mes (oct -> Oct)
  // En español el formato suele ser "05 oct 2025". Haremos que coincida con "05 Oct 2025"
  return formatted.replace(/\b([a-z])/g, (match) => match.toUpperCase());
}

/**
 * Formatea una fecha de negocio/calendario sin desplazarla por timezone.
 *
 * Útil para campos como ETD/ETA de bookings: el backend puede serializar
 * `2026-07-01 00:00:00` como `2026-07-01T00:00:00Z`; si el navegador lo
 * interpreta como instante UTC, zonas como America/New_York lo muestran como
 * `30 jun 2026`. Para fechas calendario, el día correcto es el `YYYY-MM-DD`
 * recibido.
 */
export function formatCalendarDate(date: string | Date | null | undefined): string {
  if (!date) return "—";

  let year: number;
  let monthIndex: number;
  let day: number;

  if (typeof date === "string") {
    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return "—";

    year = Number(match[1]);
    monthIndex = Number(match[2]) - 1;
    day = Number(match[3]);
  } else {
    if (isNaN(date.getTime())) return "—";

    const isoDate = date.toISOString().slice(0, 10);
    const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return "—";

    year = Number(match[1]);
    monthIndex = Number(match[2]) - 1;
    day = Number(match[3]);
  }

  const calendarDate = new Date(year, monthIndex, day);
  if (
    calendarDate.getFullYear() !== year ||
    calendarDate.getMonth() !== monthIndex ||
    calendarDate.getDate() !== day
  ) {
    return "—";
  }

  const formatted = calendarDate.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return formatted.replace(/\b([a-z])/g, (match) => match.toUpperCase());
}
